import React from 'react';

import type { ReportList } from 'api/endPoints/getReportList';

import { MenuGroupItems } from 'components/common/reportingSideMenu/components/MenuGroupItems/MenuGroupItems';

import classes from './SearchResults.module.scss';

interface Props {
    items: ReportList[];
    selectedItemId: string;
    handleItemClick: (item: ReportList) => void;
}

export const SearchResults = ({ items, selectedItemId, handleItemClick }: Props) => {
    if (items.length === 0) {
        return (
            <div className={classes.emptyState}>
                <h3 className={classes.emptyStateTitle}>No results found</h3>
                <p className={classes.emptyStateDescription}>
                    No reports match your search, or you don't have access to them.
                </p>
            </div>
        );
    }

    return (
        <div className={classes.searchItemsWrapper}>
            <MenuGroupItems items={items} selectedItemId={selectedItemId} handleItemClick={handleItemClick} />
        </div>
    );
};
